import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';

import { Observable } from "rxjs";
import { ConfigurationService } from '../services/configuration.service';


@Injectable({
  providedIn: 'root'
})

export class AgreementService {

  constructor(private http: HttpClient,
    private configurations: ConfigurationService) {
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + "/api/Agreement/getAll");
  }

  save(item) {
    return this.http.post(this.configurations.apiAddress + "/api/Agreement/save", item);
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/Agreement/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Agreement/getById/' + id);
  }

  getAgreementsByHcpId(hcpId: number, dateFrom, dateTo) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString());
    return this.http.get(this.configurations.apiAddress + '/api/Agreement/getAgreementsByHcpId/' + hcpId, { params: myParams });
  }

  getAgreementsByHcoId(hcoId: number, dateFrom, dateTo) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString());
    return this.http.get(this.configurations.apiAddress + '/api/Agreement/getAgreementsByHcoId/' + hcoId, { params: myParams });
  }

  getTotalHcpAgreementsCount(hcpId: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Agreement/getTotalHcpAgreementsCount/' + hcpId);
  }

  getTotalHcoAgreementsCount(hcoId: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Agreement/getTotalHcoAgreementsCount/' + hcoId);
  }

}
